import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addProduct, deleteProduct, getProducts, updateProduct } from 'src/redux/products'
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CButtonGroup,
  CCol,
  CContainer,
  CRow,
  CCard,
  CCardBody,
  CCardImage,
  CCardText,
  CCardTitle,
  CPlaceholder,
  CButtonToolbar,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CTable,
  CTableRow,
  CTableBody,
  CTableDataCell,
  CForm,
  CFormSelect,
  CFormInput,
  CImage,
  CFormText,
  CFormTextarea,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTouchApp, cilPencil, cilTrash, cilPlus, cilMinus } from '@coreui/icons'
import swal from 'sweetalert'
import { toast } from 'react-toastify'
import { getMenus } from 'src/redux/menus'

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedSubcategory, setSelectedSubcategory] = useState(null)
  const [selectedProduct, setSelectedProduct] = useState(null) // Track selected product
  const [modalVisible, setModalVisible] = useState(false) // Modal state
  const [formData, setFormData] = useState({})
  const [image, setImage] = useState(null)

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, images: file })
  }

  const dispatch = useDispatch()
  const { products, loading } = useSelector((state) => state.products)
  const { menusData } = useSelector((state) => state.menus)

  useEffect(() => {
    dispatch(getMenus())
  }, [dispatch])

  useEffect(() => {
    if (selectedSubcategory) {
      dispatch(getProducts(selectedCategory, selectedSubcategory))
    }
  }, [dispatch, selectedSubcategory])

  const handleView = (product) => {
    setSelectedProduct(product)
    setModalVisible(true)
  }

  const handleSubmit = async () => {
    if (!formData.name) {
      toast('Name is required!', { type: 'info' })
    } else if (!formData.images) {
      toast('Image is required!', { type: 'info' })
    } else if (!formData.category) {
      toast('Category is required!', { type: 'info' })
    } else if (!formData.sub_category) {
      toast('Sub-category is required!', { type: 'info' })
    } else if (!formData.price) {
      toast('Price is required!', { type: 'info' })
    } else if (!formData.weight) {
      toast('Weight is required!', { type: 'info' })
    } else if (!formData.pieces) {
      toast('Pieces count is required!', { type: 'info' })
    } else if (!formData.serves) {
      toast('Serves count is required!', { type: 'info' })
    } else if (!formData.description) {
      toast('Description is required!', { type: 'info' })
    } else if (!formData.stock) {
      toast('Stock is required!', { type: 'info' })
    } else {
      const body = {
        name: formData.name,
        category: formData.category,
        sub_category: formData.sub_category,
        price: formData.price,
        weight: formData.weight,
        pieces: formData.pieces,
        serves: formData.serves,
        images: formData.images,
        description: formData.description,
        stock: formData.stock,
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(addProduct(formDataToSend, body))
        setFormData({ category: '0', sub_category: '0' })
        setImage(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  const handleUpdate = async (id) => {
    if (!formData.name) {
      toast('Name is required!', { type: 'info' })
    } else if (!formData.images) {
      toast('Image is required!', { type: 'info' })
    } else if (!formData.category) {
      toast('Category is required!', { type: 'info' })
    } else if (!formData.sub_category) {
      toast('Sub-category is required!', { type: 'info' })
    } else if (!formData.price) {
      toast('Price is required!', { type: 'info' })
    } else if (!formData.weight) {
      toast('Weight is required!', { type: 'info' })
    } else if (!formData.pieces) {
      toast('Pieces count is required!', { type: 'info' })
    } else if (!formData.serves) {
      toast('Serves count is required!', { type: 'info' })
    } else if (!formData.description) {
      toast('Description is required!', { type: 'info' })
    } else if (!formData.stock) {
      toast('Stock is required!', { type: 'info' })
    } else {
      const body = {
        uuid: formData.uuid,
        name: formData.name,
        category: formData.category,
        sub_category: formData.sub_category,
        price: formData.price,
        weight: formData.weight,
        pieces: formData.pieces,
        serves: formData.serves,
        images: formData.images,
        description: formData.description,
        stock: formData.stock,
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(updateProduct(formDataToSend, body))
        setFormData({ category: '0', sub_category: '0' })
        setImage(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  const handleDelete = async (id) => {
    await swal({
      title: 'Are you sure? ',
      text: 'You want to delete this Product!',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(deleteProduct(id, selectedCategory, selectedSubcategory))
      } else {
        console.log(willDelete)
      }
    })
  }

  const handlePlusMinus = async (item, e) => {
    try {
      const body = { ...item, stock: e === 'plus' ? item.stock + 1 : item.stock - 1 }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })

      await dispatch(updateProduct(formDataToSend, body))
    } catch (error) {
      toast(error.message, { type: 'error' })
    }
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={8}>
            <CAccordion activeItemKey={selectedCategory}>
              {menusData?.map((menu) => (
                <CAccordionItem key={menu.id} itemKey={menu.id}>
                  <CAccordionHeader onClick={() => setSelectedCategory(menu.id)}>
                    {menu.name}
                  </CAccordionHeader>
                  <CAccordionBody>
                    <CButtonGroup role="group" aria-label="Subcategory Selection">
                      {menu?.subcategories?.length > 0 ? (
                        menu.subcategories.map((sub) => (
                          <CButton
                            key={sub.id}
                            color="primary"
                            variant="outline"
                            onClick={() => setSelectedSubcategory(sub.id)}
                            active={sub.id === selectedSubcategory}
                          >
                            {sub.name}
                          </CButton>
                        ))
                      ) : (
                        <p className="text-muted pt-2 ps-2">No subcategories available</p>
                      )}
                    </CButtonGroup>

                    {selectedCategory === menu.id && (
                      <div className="d-flex flex-wrap justify-content-start gap-2 mt-3">
                        {loading ? (
                          [...Array(3)].map((_, index) => (
                            <CCard style={{ width: '16rem' }} key={index}>
                              <CPlaceholder component={CCardImage} height={180} />
                              <CCardBody>
                                <CPlaceholder as={CCardTitle} animation="glow">
                                  <CPlaceholder xs={7} />
                                </CPlaceholder>
                                <CPlaceholder as={CCardText} animation="glow">
                                  <CPlaceholder xs={6} />
                                  <CPlaceholder xs={8} />
                                </CPlaceholder>
                                <CPlaceholder as={CButton} color="primary" xs={6} />
                              </CCardBody>
                            </CCard>
                          ))
                        ) : products?.length > 0 ? (
                          products?.map(
                            (item) =>
                              Number(item.category) === selectedCategory && (
                                <CCard style={{ width: '16rem' }} key={item.id}>
                                  <CCardImage
                                    orientation="top"
                                    src={item.images || 'placeholder.jpg'}
                                    alt={item.name}
                                    width={100}
                                    height={180}
                                  />
                                  <CCardBody>
                                    <CCardTitle>{item.name}</CCardTitle>
                                    <CCardText className="d-flex gap-4">
                                      <div>
                                        <strong>Price:</strong> ₹{item.price} <br />
                                        <strong>Weight:</strong> {item.weight} <br />
                                      </div>
                                      <div>
                                        <strong>Pieces:</strong> {item.pieces} <br />
                                        <strong>Serves:</strong> {item.serves} <br />
                                      </div>
                                    </CCardText>
                                    <CButtonToolbar className="d-flex gap-1">
                                      <CButton
                                        color="info"
                                        variant="outline"
                                        size="sm"
                                        onClick={() => handleView(item)}
                                      >
                                        <CIcon icon={cilTouchApp} />
                                      </CButton>
                                      <CButton
                                        color="warning"
                                        variant="outline"
                                        size="sm"
                                        onClick={() => setFormData(item)}
                                      >
                                        <CIcon icon={cilPencil} />
                                      </CButton>
                                      <CButton
                                        color="danger"
                                        variant="outline"
                                        size="sm"
                                        onClick={() => handleDelete(item.id)}
                                      >
                                        <CIcon icon={cilTrash} />
                                      </CButton>
                                      <CButtonGroup>
                                        <CButton
                                          color="success"
                                          size="sm"
                                          onClick={() => handlePlusMinus(item, 'minus')}
                                          disabled={item.stock === 0 ? true : false}
                                        >
                                          <CIcon icon={cilMinus} className="text-black" />
                                        </CButton>
                                        <CButton
                                          color="success"
                                          variant="outline"
                                          size="sm"
                                          disabled
                                        >
                                          <strong className="text-black">{item.stock}</strong>
                                        </CButton>
                                        <CButton
                                          color="success"
                                          size="sm"
                                          onClick={() => handlePlusMinus(item, 'plus')}
                                          disabled={item.stock >= 10 ? true : false}
                                        >
                                          <CIcon icon={cilPlus} className="text-black" />
                                        </CButton>
                                      </CButtonGroup>
                                    </CButtonToolbar>
                                  </CCardBody>
                                </CCard>
                              ),
                          )
                        ) : (
                          <p className="text-muted">No products available</p>
                        )}
                      </div>
                    )}
                  </CAccordionBody>
                </CAccordionItem>
              ))}
            </CAccordion>
          </CCol>
          <CCol md={9} lg={7} xl={4}>
            <CCard className="mb-2">
              <CCardBody className="p-4">
                <CForm>
                  <h5 className="text-medium-emphasis mb-3">
                    {formData?.id ? 'Update' : 'Add'} Product
                  </h5>

                  <CFormSelect
                    id="categoryId"
                    label="Category"
                    className="mb-3"
                    feedbackInvalid="Please provide a Category"
                    value={formData.category}
                    onChange={(e) => {
                      const selectedCategoryId = e.target.value
                      setFormData({ ...formData, category: selectedCategoryId, sub_category: '' })
                    }}
                    required
                  >
                    <option value="0">Select Category</option>
                    {menusData?.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </CFormSelect>

                  <CFormSelect
                    id="subCategoryId"
                    label="Sub Category"
                    className="mb-3"
                    feedbackInvalid="Please provide a Sub Category"
                    value={formData.sub_category}
                    onChange={(e) => setFormData({ ...formData, sub_category: e.target.value })}
                    required
                    disabled={!formData.category}
                  >
                    <option value="0">Select Sub Category</option>
                    {menusData
                      ?.find((category) => category.id === Number(formData.category))
                      ?.subcategories.map((sub) => (
                        <option value={sub.id} key={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                  </CFormSelect>

                  <CFormInput
                    placeholder="Product Name"
                    label="Product Name"
                    className="mb-3"
                    value={formData.name || ''}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />

                  <CFormInput
                    placeholder="Price"
                    label="Price (INR)"
                    type="number"
                    className="mb-3"
                    value={formData.price || ''}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  />

                  <CFormInput
                    placeholder="Weight"
                    label="Weight (e.g., 1kg)"
                    className="mb-3"
                    value={formData.weight || ''}
                    onChange={(e) => setFormData({ ...formData, weight: e.target.value })}
                  />

                  <CFormInput
                    placeholder="Number of Pieces"
                    label="Pieces"
                    type="number"
                    className="mb-3"
                    value={formData.pieces || ''}
                    onChange={(e) => setFormData({ ...formData, pieces: e.target.value })}
                  />

                  <CFormInput
                    placeholder="Serves (e.g., 1-8 people)"
                    label="Serves"
                    className="mb-3"
                    value={formData.serves || ''}
                    onChange={(e) => setFormData({ ...formData, serves: e.target.value })}
                  />

                  <CFormTextarea
                    placeholder="Product Description"
                    label="Description"
                    className="mb-3"
                    value={formData.description || ''}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  />

                  <CFormInput
                    placeholder="Stock Quantity"
                    label="Stock"
                    type="number"
                    className="mb-3"
                    value={formData.stock || ''}
                    onChange={(e) => setFormData({ ...formData, stock: e.target.value })}
                  />

                  <div className="mb-3">
                    <CFormText>Select Image</CFormText>
                    <CFormInput type="file" size="sm" id="pickImage" onChange={handleImageChange} />
                  </div>

                  {image && (
                    <CImage
                      src={image}
                      style={{
                        width: '100%',
                        height: 150,
                        justifyContent: 'center',
                      }}
                    />
                  )}

                  <div className="d-grid mt-3">
                    <CButton color="success" onClick={formData?.id ? handleUpdate : handleSubmit}>
                      {formData?.id ? 'Update' : 'Submit'}
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>

      <CModal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader closeButton>
          <CModalTitle>{selectedProduct?.name}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {selectedProduct && (
            <>
              <img
                src={selectedProduct.images || 'placeholder.jpg'}
                alt={selectedProduct.name}
                className="img-fluid mb-3"
                style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
              />
              <CContainer>
                <CTable striped bordered hover responsive>
                  <CTableBody>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Weight</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.weight}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Pieces</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.pieces}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Serves</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.serves}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Price</strong>
                      </CTableDataCell>
                      <CTableDataCell>₹{selectedProduct.price}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableDataCell>
                        <strong>Stock</strong>
                      </CTableDataCell>
                      <CTableDataCell>{selectedProduct.stock}</CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>
              </CContainer>
              <CCardText>
                <strong>Description:</strong> {selectedProduct.description}
              </CCardText>
            </>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setModalVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default Products
